'use client';

import { useLayoutEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { collapseDuplicateAppBasePath, pathForNextNavigation } from '@/lib/appBasePath';

/**
 * Middleware only runs on full HTTP requests. Client-side `router.push` / `<Link href="/v2/...">`
 * can leave the address bar at `/v2/v2/...` without a round trip; normalize via `router.replace`.
 */
export function DuplicateBasePathRepair() {
  const router = useRouter();
  const pathname = usePathname();

  useLayoutEffect(() => {
    const full = window.location.pathname;
    const collapsed = collapseDuplicateAppBasePath(full);
    if (collapsed === full) return;

    const nextPath = pathForNextNavigation(collapsed);
    router.replace(`${nextPath}${window.location.search}${window.location.hash}`);
  }, [router, pathname]);

  return null;
}
